import styled from 'styled-components'


export const UnitsInputContainer = styled.div`
    display: flex;
`